import React from 'react';

type InputProps = {
  senderName: string | null | undefined;
  isScheduledToSend: boolean;
  formattedSendDateTime: string;
};

export const TextMessageHeader = ({
  senderName,
  isScheduledToSend,
  formattedSendDateTime,
}: InputProps) => {
  if (!senderName) {
    return null;
  }

  return (
    <div className="typo-subtitle">
      {senderName} {isScheduledToSend ? 'scheduled for' : 'sent on'} {formattedSendDateTime}
    </div>
  );
};
